import React, { useContext } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { BrandContext } from "./BrandContext.js";

const EmptyHeroImage = () => {
  return (
    <div className="h-64 bg-venue-brand pattern-hideout text-venue-foreground" />
  );
};

const HeroImage = ({ venue }) => {
  const hasImage = (image) => image && image != "/assets/missing.png";
  return hasImage(venue.heroImageUrl) ? (
    <div className="h-128 overflow-hidden flex items-center">
      <img className="object-cover w-full " src={venue.heroImageUrl} />
    </div>
  ) : (
    <EmptyHeroImage />
  );
};

const LogoImage = ({ venue }) => {
  const { isPlayful, isElegant, isSimple, isBrutalist, ...venueBrand } =
    useContext(BrandContext);

  const hasImage = (image) => image && image != "/assets/missing.png";
  if (!hasImage(venue.logoImageUrl)) {
    return null;
  }
  return (
    <div className="flex-shrink-0 h-0 w-96">
      <div
        className={classnames("bg-white absolute transform -translate-y-1/2 ", {
          "shadow-brutalist": isBrutalist,
          "rounded-lg": isPlayful,
          "rounded  shadow": isSimple,
          shadow: isElegant,
        })}
      >
        <img
          className={classnames("object-cover h-96", {
            "rounded-lg shadow": isPlayful,
            "rounded  shadow": isSimple,
            "": isElegant,
          })}
          src={venue.logoImageUrl}
        />
      </div>
    </div>
  );
};
const DefaultVenueComponents = {
  HeroImage,
  LogoImage,
};
const VenueHeader = ({ venue, menuUpdatedAt, VenueComponents }) => {
  const { HeroImage, LogoImage } = {
    ...DefaultVenueComponents,
    ...VenueComponents,
  };
  const { t } = useTranslation();
  const { isPlayful, isElegant, isSimple, isBrutalist, ...venueBrand } =
    useContext(BrandContext);

  return (
    <React.Fragment>
      <div className="relative space-y-16 mb-24">
        <HeroImage venue={venue} />
        <div className="flex space-x-24 px-16 md:px-32">
          <LogoImage venue={venue} />
          <div className="flex-1 whitespace-pre-line space-y-4">
            <div
              className={classnames("font-bold text-neutral-700 ", {
                "font-light text-lg": isElegant,
              })}
            >
              {venue.name}
            </div>
            <div className="text-xs text-neutral-500">{venue.address}</div>
            <div
              className="cursor-pointer text-xs hover:underline text-venue-brand"
              onClick={() => window.open(`tel:${venue.companyPhone}`)}
            >
              {venue.companyPhone}
            </div>
            <div className="text-xs text-neutral-500">{venue.openingHours}</div>

            {menuUpdatedAt && (
              <div className="text-xs text-neutral-500">
                {t("publicMenus.menuUpdatedOn", { date: menuUpdatedAt })}
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export const CondensedVenueHeader = ({ venue, menuUpdatedAt }) => {
  const { isPlayful, isElegant, isSimple, isBrutalist, ...venueBrand } =
    useContext(BrandContext);

  const hasImage = (image) => image && image != "/assets/missing.png";
  return (
    <React.Fragment>
      <div className="relative space-y-16 mb-24 bg-white">
        {hasImage(venue.heroImageUrl) ? (
          <div className="h-128 overflow-hidden flex items-center">
            <img className="object-cover w-full " src={venue.heroImageUrl} />
          </div>
        ) : (
          <div className="h-64 bg-venue-brand pattern-hideout text-venue-foreground" />
        )}
        <div className="flex space-x-24 px-16 md:px-32">
          {hasImage(venue.logoImageUrl) && (
            <div className="flex-shrink-0 h-0 w-96">
              <div
                className={classnames(
                  "bg-white absolute transform -translate-y-1/2  mb-48",
                  {
                    "shadow-brutalist": isBrutalist,
                    "rounded-lg": isPlayful,
                    "rounded  shadow": isSimple,
                    shadow: isElegant,
                  }
                )}
              >
                <img
                  className={classnames("object-cover h-96", {
                    "rounded-lg shadow": isPlayful,
                    "rounded  shadow": isSimple,
                    "": isElegant,
                  })}
                  src={venue.logoImageUrl}
                />
              </div>
            </div>
          )}
          <div className="flex-1 whitespace-pre-line space-y-4">
            <div
              className={classnames("font-semibold text-neutral-700 ", {
                "font-light text-lg": isElegant,
              })}
            >
              {venue.name}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default VenueHeader;
